/**
 * Cloudinary URLs for HEIC (and other poorly supported formats) break in browsers and email.
 * Returns a URL that forces a web-safe format (e.g. JPG) via Cloudinary transformations.
 * @param {string} url - Cloudinary URL (e.g. secure_url or url from upload result)
 * @returns {string} URL with f_jpg,q_auto so the image displays in browsers and email clients
 */
export function getCloudinaryDisplayUrl(url) {
	if (!url || typeof url !== 'string') return url;
	let u = url;
	if (u.startsWith('http://res.cloudinary.com')) {
		u = `https://${u.slice('http://'.length)}`;
	}
	if (!u.includes('res.cloudinary.com') || !u.includes('/upload/')) return u;
	return u.replace('/upload/', '/upload/f_jpg,q_auto/');
}
